export const SET_ERROR_CODE_MESSAGE = 'SET_ERROR_CODE_MESSAGE';

export const setErrorCodeMessage = (errorCodeMessage) => ({
    type: SET_ERROR_CODE_MESSAGE, errorCodeMessage
});
